/*
 * @Author: liusihan
 * @Date: 2020-09-11 09:05:54
 * @LastEditTime: 2021-06-24 16:39:13
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\pages\home\services\index.ts
 */
import instance from '@/service'
import { ResponseCode } from '@/commons/enums'
import { DataStatistics } from '../models/DataStatistics'
import { NewsResponse, News } from '../models/InformationNews'
import { FeaturesEnterpriseItem } from '../models/FeaturesEnterprise'
import { ContactUs } from '../models/ContactUs'
import { parseTime } from '@/utils/tool'
import { IndexInfomationNavModel } from '../model'

export class DataStatisticsService {
  // constructor () {}

  async getDataStatisticsService (): Promise<DataStatistics> {
    const response = await instance.get('/api/v1/stat/')
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return {
        studentsTotal: 0,
        offerCourseAmount: 0,
        jobsAmount: 0,
        courseCertification: ''
      }
    }
    (response as any).data = response.data
    const data = response.data
    return new DataStatistics(
      data.students,
      data.lessons,
      data.professions,
      '国培网'
    )
  }
}
export class InformationNewsService {
  async getInfomationNavs (): Promise<Array<IndexInfomationNavModel>> {
    const result = await instance.get('/api/v1/menu/homePage/')
    return result.data.items.map((item: any) => {
      return new IndexInfomationNavModel(item.id, item.name)
    })
  }
  // constructor () {}

  async getInformationNewsService (page: number, pageSize: number, menuId: string): Promise<NewsResponse> {
    const response = await instance.get(`/api/v1/information/?menuId=${menuId}&page=${page}&size=${pageSize}&moduleKey=app_information`)
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return {
        newsList: [],
        total: 0
      }
    }
    (response as any).data = response.data
    const data = response.data
    return new NewsResponse(
      data.items.map((item: any) => {
        return new News(item.id, item.name, parseTime(item.createAt, ''), item.imageUrl, item.abstracts, item.content)
      }),
      data.total
    )
  }

  async getHomeMenus (): Promise<any> {
    const res = await instance.get('/api/v1/menu/homePage/')
    if (res && res.data && res.data.items) {
      return res.data.items
    }
    return []
  }
}

export class FeaturesEnterpriseService {
  // constructor () {}
  async getFeaturesEnterpriseService
  (page: number, pageSize: number, menuId: number): Promise<NewsResponse> {
    const response = await instance.get(`/api/v1/information/?menuId=${menuId}&page=${page}&size=${pageSize}&moduleKey=app_campus_style`)
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return {
        newsList: [],
        total: 0
      }
    }
    (response as any).data = response.data
    const data = response.data
    return new NewsResponse(
      data.items.map((item: any) => {
        console.log(item.imageUrl)
        return new FeaturesEnterpriseItem(
          item.id,
          item.imageUrl,
          item.name,
          item.abstracts,
          item.content,
          parseTime(item.createAt, ''))
      }),
      data.total
    )
  }
}

const fakeData3 = {
  address: '北京紫荆花孵化器kdk304',
  person: '刘老师',
  telphone: '198484984',
  email: '19494@qq.com'
}
export class ContactUsService {
  // constructor () {}

  async getContactUsService (): Promise<ContactUs> {
    const response = await instance.get('/api/v1/configuration/center/single?moduleKey=web_contact_us')
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return {
        addr: '',
        contactPerson: '',
        tel: '',
        email: '',
        qrcode: ''
      }
    }
    (response as any).data = response.data
    const data = response.data
    return new ContactUs(
      this.filterPropNameGetValue(data.properties, 'web_contact_us/school_address'),
      this.filterPropNameGetValue(data.properties, 'web_contact_us/contact_person'),
      this.filterPropNameGetValue(data.properties, 'web_contact_us/phone'),
      this.filterPropNameGetValue(data.properties, 'web_contact_us/email'),
      this.filterPropNameGetValue(data.properties, 'web_contact_us/QR_code')
    )
  }

  filterPropNameGetValue (list: any, key: string) {
    const filteredList = list.filter((item: any) => {
      return item.moduleKey === key
    })
    return filteredList[0].moduleValue
  }
}

export class Config {
  async gethomeConfigService (status: string): Promise<any> {
    const response = await instance.get(`/api/v1/configuration/center?moduleStatus=${status}`)
    if ((response as any).code !== ResponseCode.SUCCESS) {
      return {}
    }
    (response as any).data = response.data
    localStorage.setItem('organizationTitle', response.data.organizationTitle)
    const data = response.data
    return data.moduleList
  }
}
